import { Layouts } from 'react-grid-layout';
import CopyAndCreateAction from '../../components/AnalyticsMappings/actions/CopyAndCreateAction';
import DeleteMappingsAction from '../../components/AnalyticsMappings/actions/DeleteMappingsAction';
import EditMappingsActions from '../../components/AnalyticsMappings/actions/EditMappingsActions';
import MappingsActions from '../../components/AnalyticsMappings/actions/MappingsActions';

export const layoutConfig: Layouts | undefined = {
    lg: [
        {
            h: 1,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
        {
            h: 14,
            static: true,
            w: 24,
            x: 0,
            y: 1,
            i: 'c2',
        },
    ],
    md: [
        {
            h: 1,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
        {
            h: 14,
            static: true,
            w: 24,
            x: 0,
            y: 1,
            i: 'c2',
        },
    ],
    xs: [
        {
            h: 1,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
        {
            h: 14,
            static: true,
            w: 24,
            x: 0,
            y: 1,
            i: 'c2',
        },
    ],
};
export const pageConfig: PageConfig = {
    pageProps: {},
    components: [
        {
            name: 'mapping-action-bar',
            key: 'c1',
            props: {},
        },
        {
            name: 'canopy-table',
            key: 'c2',
            apiDetails: {
                endpoint: `tableau-details/all?`,
                endpointParams: {
                    sort_column: 'sortColumn',
                    sort_direction: 'sortDirection',
                    per_page: '*,per_page',
                    page: '*,page',
                    keyword: 'keyword',
                },
            },
            props: {
                headerText: 'analytics-mappings',
                requiredQueryFields: ['parent_user_ids'],
                dataKey: 'mappings',
                title: '',
                CustomAction: <MappingsActions />,
                canSelectRows: true,
                showDownloadOn: ['desktop', 'tablet'],
                columns: [
                    {
                        key: 'username',
                        otherKeys: ['userId'],
                        type: 'splitCell',
                        headerText: 'username',
                        selectedByDefaultOn: ['desktop', 'tablet', 'mobile'],
                        canSort: true,
                        canReorder: false,
                    },
                    {
                        key: 'adminUsername',
                        type: 'text',
                        headerText: 'table-headers.pa-rm-name',
                        selectedByDefaultOn: ['desktop', 'tablet'],
                        canSort: true,
                    },
                    {
                        key: 'submenuWorkbook',
                        type: 'workbookAnalytics',
                        headerText: 'table-headers.workbook-name',
                        selectedByDefaultOn: ['desktop', 'tablet'],
                        canSort: false,
                    },
                    {
                        key: 'adminRole',
                        type: 'text',
                        headerText: 'table-headers.admin-role',
                        selectedByDefaultOn: [''],
                        canSort: true,
                    },
                    {
                        key: 'device',
                        type: 'text',
                        headerText: 'table-headers.device-type',
                        selectedByDefaultOn: ['desktop', 'tablet'],
                        canSort: true,
                    },
                    {
                        key: 'createdAt',
                        type: 'date',
                        headerText: 'table-headers.created-at',
                        canSort: true,
                    },
                    {
                        key: 'updatedAt',
                        type: 'date',
                        headerText: 'table-headers.updated-at',
                        canSort: true,
                    },
                    {
                        key: 'actions',
                        type: 'actions',
                        showOnParentTable: true,
                        actions: [
                            {
                                name: 'copy_mapping_button',

                                Component: <CopyAndCreateAction />,
                                selectedByDefaultOn: [
                                    'desktop',
                                    'tablet',
                                    'mobile',
                                ],
                            },
                            {
                                name: 'edit-mapping-action',

                                Component: <EditMappingsActions />,
                                selectedByDefaultOn: [
                                    'desktop',
                                    'tablet',
                                    'mobile',
                                ],
                            },
                            {
                                name: 'delete_file',

                                Component: <DeleteMappingsAction />,
                                selectedByDefaultOn: [
                                    'desktop',
                                    'mobile',
                                    'tablet',
                                ],
                            },
                        ],
                        headerText: 'table-headers.actions',
                        selectedByDefaultOn: ['desktop', 'tablet', 'mobile'],
                        ga_event_name: 'Documents',
                    },
                ],
                per_page: 25,
                ga_event_name: 'Analytics Mappings',
            },
        },
    ],
};
